export default "__VITE_ASSET__22fbecd1__"